"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var generateUrls = function generateUrls(env) {
  var windowOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var environment = windowOrigin && windowOrigin.includes('sl') ? 'sl' : 'e3';

  if (env === 'integration') {
    environment = 'e1';
  } else if (env === 'qa') {
    environment = 'e2';
  }

  var GRAAS_ENDPOINT = (global.BROWSER ? {
    e1: 'https://graaswebspa-dev.americanexpress.com/orchestration/',
    e2: 'https://e2qrewards.americanexpress.com/orchestration/',
    sl: 'https://slgraaswebspa.americanexpress.com/orchestration/',
    e3: 'https://rewards.americanexpress.com/orchestration/'
  } : {
    e1: 'http://mycaservicese1qrewards.webqa.ipc.us.aexp.com:5555/orchestration/',
    e2: 'http://mycaservicese2qrewards.webqa.ipc.us.aexp.com:5555/orchestration/',
    sl: 'http://mycaservicesrewards.web.ipc.us.aexp.com:5555/orchestration/',
    e3: 'http://mycaservicesrewards.web.ipc.us.aexp.com:5555/orchestration/'
  })[environment];
  var CORPORATE_URL = {
    e1: 'https://business.americanexpress.com/us/card-member/corporate-benefits/corporate-credit-card',
    e2: 'https://business.americanexpress.com/us/card-member/corporate-benefits/corporate-credit-card',
    sl: 'https://business.americanexpress.com/us/card-member/corporate-benefits/corporate-credit-card',
    e3: 'https://business.americanexpress.com/us/card-member/corporate-benefits/corporate-credit-card'
  }[environment];
  var LEGACY_ROOT = {
    e1: 'https://e1qonline.americanexpress.com/us/credit-cards/benefits',
    e2: 'https://e2qonline.americanexpress.com/us/credit-cards/benefits',
    sl: 'https://online.americanexpress.com/us/credit-cards/benefits',
    e3: 'https://online.americanexpress.com/us/credit-cards/benefits'
  }[environment];
  var MYCA_LOGIN_URL = {
    e1: 'https://one-dev.americanexpress.com/en-us/account/login?DestPage=',
    e2: 'https://qwww.americanexpress.com/en-us/account/login?DestPage=',
    sl: 'https://www.americanexpress.com/en-us/account/login?DestPage=',
    e3: 'https://www.americanexpress.com/en-us/account/login?DestPage='
  }[environment];
  var CENTURION_LOGIN_URL = {
    e1: 'https://one-dev.americanexpress.com/en-us/account/centurion/login?DestPage=',
    e2: 'https://qwww.americanexpress.com/en-us/account/centurion/login?DestPage=',
    sl: 'https://www.americanexpress.com/en-us/account/centurion/login?DestPage=',
    e3: 'https://www.americanexpress.com/en-us/account/centurion/login?DestPage='
  }[environment];
  var CENTURION_HUB_URL = {
    e1: 'https://dwww.americanexpress.com/us/benefits/centurion/',
    e2: 'https://qwww.americanexpress.com/us/benefits/centurion/',
    sl: 'https://origin-slgem.americanexpress.com/us/benefits/centurion/',
    e3: 'https://www.americanexpress.com/us/benefits/centurion/'
  }[environment];
  return {
    GRAAS_ENDPOINT: GRAAS_ENDPOINT,
    CORPORATE_URL: CORPORATE_URL,
    LEGACY_ROOT: LEGACY_ROOT,
    MYCA_LOGIN_URL: MYCA_LOGIN_URL,
    CENTURION_LOGIN_URL: CENTURION_LOGIN_URL,
    CENTURION_HUB_URL: CENTURION_HUB_URL
  };
};

var _default = generateUrls;
exports.default = _default;